import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplateHtmlModule } from './template-html/template-html.module';
import { ConfigurationModule } from './configuration/configuration.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TemplateHtmlModule,
    ConfigurationModule
  ],
  exports: [TemplateHtmlModule, ConfigurationModule]
})
export class LandingPageModule { }
